const CURRENCY_FORMATTER = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    currencySign: 'accounting',
});

const AMOUNT_ZERO = CURRENCY_FORMATTER.format(0);

export const usdValueFormatter = ({ value, data }) => {
    const currentValue = Number(value);
    if (isNaN(currentValue)) {
        return '';
    }
    if (data.subscriber_id && currentValue < 0) {
        const exceeded = CURRENCY_FORMATTER.format(
            -currentValue
        );
        return `${AMOUNT_ZERO} exceeded by ${exceeded}`;
    }
    return CURRENCY_FORMATTER.format(currentValue);
};

export const valueFormatter = ({ value, data }) => {
    const currentValue = Number(value);
    if (isNaN(currentValue)) {
        return value;
    }
    return currentValue.toLocaleString(undefined, { maximumFractionDigits: 2 });
};
